import { render, staticRenderFns } from "./MacroeconomicIndicatorsList.vue?vue&type=template&id=6115a34a&scoped=true&"
import script from "./MacroeconomicIndicatorsList.vue?vue&type=script&lang=js&"
export * from "./MacroeconomicIndicatorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6115a34a",
  null
  
)

export default component.exports